import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';

export function ReservedSlotExpired() {

    return (
        <>
            <ContentContainer className='flex-1 lg:flex-none text-center space-y-6'>
                <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
                <h1 className="text-2xl text-gray-900 font-medium">
                    Session expired
                </h1>
                <p>
                    Your booking session has ended due to inactivity.<br />
                    Please exit and restart your booking.
                </p>
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full"
                    color="gray"
                    onClick={() => window.close()} >
                    Exit
                </Button>
            </StickyBottomBar>
        </>
    );
}